module.exports = __webpack_public_path__ + "static/finelite_intro_image-8c29168a2dc8e14b1a89b7904e1f8f1b.jpg";